import { NgModule } from '@angular/core';

import { AzureSSOService } from '@d-services/other/azure-sso.service';

@NgModule({
  providers: [AzureSSOService],
})
export class AzureSSOModule {}
